import { ParseError } from "../core/errors.js";
import {
  UrlSchema,
  ChapterIndexSchema,
  AdapterIdSchema,
  IsoDateSchema,
  ResumeTokenSchema,
  type Url,
  type ChapterIndex,
  type AdapterId,
  type IsoDate,
  type ResumeToken,
} from "./primitives.js";

function preview(input: unknown): string {
  return String(input).slice(0, 80);
}

export function parseUrl(input: unknown): Url {
  const result = UrlSchema.safeParse(input);
  if (!result.success) {
    throw new ParseError(`Invalid URL: ${preview(input)}`, { cause: result.error });
  }
  return result.data;
}

export function parseChapterIndex(input: unknown): ChapterIndex {
  const result = ChapterIndexSchema.safeParse(input);
  if (!result.success) {
    throw new ParseError(`Invalid ChapterIndex: ${preview(input)}`, { cause: result.error });
  }
  return result.data;
}

export function parseAdapterId(input: unknown): AdapterId {
  const result = AdapterIdSchema.safeParse(input);
  if (!result.success) {
    throw new ParseError(`Invalid AdapterId: ${preview(input)}`, { cause: result.error });
  }
  return result.data;
}

export function parseIsoDate(input: unknown): IsoDate {
  const result = IsoDateSchema.safeParse(input);
  if (!result.success) {
    throw new ParseError(`Invalid IsoDate: ${preview(input)}`, { cause: result.error });
  }
  return result.data;
}

export function parseResumeToken(input: unknown): ResumeToken {
  const result = ResumeTokenSchema.safeParse(input);
  if (!result.success) {
    throw new ParseError(`Invalid ResumeToken: ${preview(input)}`, { cause: result.error });
  }
  return result.data;
}
